/** 环境变量 */
export const isDevOrTest = process.env.STAGE === 'test' || process.env.NODE_ENV === 'development'
